export default __webpack_public_path__ + "static/media/SYN.eec9db06.png";